<template>
  <div id="app">
    <div class="main-wrapper">
      <router-view :key="$route.fullPath"/>
    </div>
  </div>
</template>
<style>
@import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;700;900&display=swap');

* {
  font-family: 'Tajawal', sans-serif;
}
.main-wrapper{
  overflow-x: hidden;
}
</style>
<script>
export default {
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      console.log('Scroll event triggered');
      const header = document.getElementById('.header');
      if (!header) return;

      if (window.pageYOffset > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    },
  },
};
</script>

